var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5781 2.16409C11.4658 1.68627 12.5342 1.68627 13.4219 2.16409L20.9219 6.20316C21.8934 6.72635 22.4999 7.74032 22.5 8.84378V19.5C22.4999 21.1568 21.1568 22.5 19.5 22.5H4.5C2.84324 22.5 1.50015 21.1568 1.5 19.5V8.84378C1.50014 7.74032 2.10657 6.72635 3.07812 6.20316L10.5781 2.16409ZM20.9219 12.5479L15.6709 15.375L19.1055 17.2246L19.1709 17.2647C19.4856 17.4778 19.5942 17.8984 19.4102 18.2403C19.226 18.582 18.815 18.7235 18.4639 18.5782L18.3945 18.545L12.7109 15.4854C12.267 15.2463 11.733 15.2463 11.2891 15.4854L5.60547 18.545C5.24086 18.7412 4.78626 18.6048 4.58984 18.2403C4.39354 17.8756 4.52994 17.421 4.89453 17.2246L8.32812 15.375L3.07812 12.5479C3.05164 12.5336 3.02593 12.517 3 12.502V19.5C3.00015 20.3283 3.67166 21 4.5 21H19.5C20.3283 21 20.9999 20.3283 21 19.5V12.502C20.9741 12.517 20.9484 12.5336 20.9219 12.5479ZM12.7109 3.48538C12.267 3.24632 11.733 3.24632 11.2891 3.48538L3.78906 7.52347C3.30338 7.78505 3.00014 8.29214 3 8.84378V9.90628C3.0001 10.458 3.30329 10.965 3.78906 11.2266L9.91016 14.5225L10.5781 14.1641C11.4658 13.6863 12.5342 13.6863 13.4219 14.1641L14.0889 14.5225L20.2109 11.2266C20.6967 10.965 20.9999 10.458 21 9.90628V8.84378C20.9999 8.29215 20.6966 7.78505 20.2109 7.52347L12.7109 3.48538Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.28bd35e5c12c4f3d057692cc584f0005.svg";
export { ForwardRef as ReactComponent };